import React, { useEffect, useState } from "react";
import './styles.css'
import Loader from '../../../components/loader/loader.component'
import { ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom';
import Select from 'react-select'
import CommonScreenContent from "../../../components/screen/common-screen-content/commonScreenContent";
import { displayErrorToast, displaySuccessToast, isEmpty, isLoggedInUserBusiness, isLoggedInUserEmployee, isNull, removeSpecialCharAndChangeToPascal } from "../../../utils/Utils";
import { userBusinessListRequest } from '../../../redux/business/business.action'
import { businessLocationListRequest } from '../../../redux/business-location/businessLocation.action'
import { addShiftRequest, addShiftRequestStatus } from '../../../redux/shift/shift.action'
import CommonInputRow from "../../../components/input/common-input-row/commonInputRow";
import ScreenLabel from "../../../components/label/screen-label/screenLabel";
import TopButton from "../../../components/button/top-button/topButton";
import { isPermissionAllowed, PERMISSION_SUB_TYPE, PERMISSION_TYPE } from "../../../utils/PermissionUtil";
import FormFieldLabel from "../../../components/label/form-field-label/formFieldLabel";
import { API_CONSTANTS, APP_CONSTANTS, ROUTES } from "../../../utils/AppConstants";
import moment from "moment";
import CommonFormBorder from "../../../components/common-form-border/commonFormBorder";
import ButtonRow from "../../../components/button/button-row/buttonRow";
import CommonButton from "../../../components/button/common-button/commonButton";
import CommonInputFloatFull from "../../../components/input/common-input-float-full/commonInputFloatFull";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CommonCheckbox from "../../../components/common-checkbox/commonCheckbox";
import { projectListRequest } from '../../../redux/project/project.action'

const AddShift = props => {
    const { user, employeeSelectedBusiness, employeeSelectedLocation } = useSelector(state => state.user)
    const [isLoading, setLoading] = useState(false)
    const dispatch = useDispatch()
    let navigate = useNavigate();
    const { userBusinessListSuccess, userBusinessListError } = useSelector(state => state.business)
    const { businessLocationListSuccess, businessLocationListError } = useSelector(state => state.businessLocation)
    const { addShiftSuccess, addShiftError, addShiftReqStatus } = useSelector(state => state.shift)
    const { projectListSuccess, projectListError } = useSelector(state => state.project)
    const [selectedBusiness, setSelectedBusiness] = useState()
    const [selectedLocation, setSelectedLocation] = useState()
    const [name, setName] = useState('')
    const [description, setDescription] = useState('')
    const [startDate, setStartDate] = useState(new Date())
    const [startTime, setStartTime] = useState(new Date())
    const [endDate, setEndDate] = useState(new Date())
    const [endTime, setEndTime] = useState(new Date())
    const [isActive, setIsActive] = useState(false)
    const [isNominationOpen, setIsNominationOpen] = useState(false)
    const [isAssignProject, setIsAssignProject] = useState(false)
    const [selectedProject, setSelectedProject] = useState()

    useEffect(() => {
        if (isLoggedInUserBusiness(user)) {
            sessionStorage.setItem(APP_CONSTANTS.SCREEN.ADD_SHIFT, true)
            fetchBusinessList()
        }
    }, [])

    const fetchBusinessList = () => {
        setLoading(true)
        const data = {
            userId: user.data.userDetails.userId
        }
        dispatch(userBusinessListRequest(data))
    }

    const fetchBusinessLocation = () => {
        if (!isEmpty(selectedBusiness)) {
            setLoading(true)
            dispatch(businessLocationListRequest(selectedBusiness.businessId))
        }
    }

    useEffect(() => {
        if (addShiftReqStatus === API_CONSTANTS.SUCCESS_STATUS) {
            setLoading(false)
            displaySuccessToast(addShiftSuccess.data.message)
            clearFields()
        } else if (addShiftReqStatus === API_CONSTANTS.ERROR_STATUS) {
            setLoading(false)
            displayErrorToast(addShiftError.message)
        }
        if (addShiftReqStatus?.length) {
            dispatch(addShiftRequestStatus(''))
        }
    }, [addShiftSuccess, addShiftError, addShiftReqStatus])

    useEffect(() => {
        if (!isEmpty(userBusinessListSuccess)) {
            setLoading(false)
            if (sessionStorage.getItem(APP_CONSTANTS.SCREEN.ADD_SHIFT) === 'true') {
                sessionStorage.setItem(APP_CONSTANTS.SCREEN.ADD_SHIFT, false)
                setSelectedBusiness(userBusinessListSuccess.data[0])
            }
        } else if (!isEmpty(userBusinessListError)) {
            setLoading(false)
        }
    }, [userBusinessListSuccess, userBusinessListError])

    useEffect(() => {
        if (!isEmpty(businessLocationListSuccess)) {
            setLoading(false)
            setSelectedLocation(businessLocationListSuccess.data[0])
        } else if (!isEmpty(businessLocationListError)) {
            setLoading(false)
        }
    }, [businessLocationListSuccess, businessLocationListError])

    useEffect(() => {
        if (!isEmpty(projectListSuccess)) {
            setLoading(false)
        } else if (!isEmpty(projectListError)) {
            setLoading(false)
        }
    }, [projectListSuccess, projectListError])

    const fetchProjectList = () => {
        setLoading(true)
        const data = {}
        if (isLoggedInUserBusiness(user)) {
            if (!isEmpty(selectedBusiness)) {
                data.businessId = selectedBusiness.businessId
                data.locationId = selectedLocation.locationId
            }
        }
        if (isLoggedInUserEmployee(user)) {
            data.businessId = employeeSelectedBusiness
            data.locationId = employeeSelectedLocation
        }
        dispatch(projectListRequest(data))
    }

    useEffect(() => {
        if (isLoggedInUserBusiness(user) === true && !isNull(selectedBusiness)) {
            fetchBusinessLocation()
        }
    }, [selectedBusiness])

    const handleSubmitClick = () => {
        if (isEmpty(name)) {
            displayErrorToast('Shift name cannot be blank')
        } else if (isNull(startDate)) {
            displayErrorToast('Shift start date not selected')
        } else if (isNull(endDate)) {
            displayErrorToast('Shift end date not selected')
        } else if (isNull(startTime)) {
            displayErrorToast('Shift start time not selected')
        } else if (isNull(endTime)) {
            displayErrorToast('Shift end time not selected')
        } else if (isLoggedInUserBusiness(user) && isNull(selectedBusiness)) {
            displayErrorToast('Business not selected')
        } else if (isLoggedInUserBusiness(user) && isNull(selectedLocation)) {
            displayErrorToast('Business location not selected')
        } else {
            const data = {
                name: name,
                businessId: isLoggedInUserBusiness(user) ? selectedBusiness.businessId : employeeSelectedBusiness,
                locationId: isLoggedInUserBusiness(user) ? selectedLocation.locationId : employeeSelectedLocation,
                startDate: startDate,
                endDate: endDate,
                startTime: startTime,
                endTime: endTime,
                isActive: isActive,
                openForNomination: isNominationOpen
            }
            if (isAssignProject && !isEmpty(selectedProject)) {
                data.projectId = selectedProject.projectId
            }
            setLoading(true)
            dispatch(addShiftRequest(data))
        }
    }

    const clearFields = () => {
        setName('')
        setDescription('')
        setStartDate(new Date())
        setStartTime(new Date())
        setEndDate(new Date())
        setEndTime(new Date())
        setSelectedProject(undefined)
        setIsActive(false)
        setIsAssignProject(false)
        setIsNominationOpen(false)
    }

    useEffect(() => {
        if (isAssignProject === true) {
            fetchProjectList()
            setSelectedProject(undefined)
        } else {
            setSelectedProject(undefined)
        }
    }, [isAssignProject])

    return (
        <>
            <CommonScreenContent>
                <ScreenLabel label='New Shift' />
                <CommonFormBorder>
                    <FormFieldLabel label='Enter details to add new shift' />
                    <CommonInputFloatFull
                        id='name'
                        type='text'
                        placeholder='Shift Name'
                        value={name}
                        onChange={e => setName(e.target.value)}
                    />
                    <CommonInputFloatFull
                        id='description'
                        type='text'
                        placeholder='Shift Description'
                        value={description}
                        onChange={e => setDescription(e.target.value)}
                        rows={3}
                        multiline={true}
                    />
                    <CommonInputRow>
                        <div className="as-date-parent-container">
                            <FormFieldLabel label='Start Date' />
                            <DatePicker
                                className="as-date-container"
                                selected={startDate}
                                minDate={new Date()}
                                onChange={(date) => {
                                    setStartDate(date)
                                    setEndDate(date)
                                }}
                                dateFormat="MMMM d, yyyy"
                            />
                        </div>
                        <div className="as-date-parent-container">
                            <FormFieldLabel label='End Date' />
                            <DatePicker
                                className="as-date-container"
                                selected={endDate}
                                onChange={(date) => setEndDate(date)}
                                dateFormat="MMMM d, yyyy"
                                minDate={startDate}
                            />
                        </div>
                    </CommonInputRow>
                    <CommonInputRow>
                        <div className="as-date-parent-container">
                            <FormFieldLabel label='Start Time' />
                            <DatePicker
                                className="as-date-container"
                                selected={startTime}
                                onChange={(date) => {
                                    setStartTime(date)
                                }}
                                showTimeSelect
                                showTimeSelectOnly
                                dateFormat="hh:mm a"
                            />
                        </div>
                        <div className="as-date-parent-container">
                            <FormFieldLabel label='End Time' />
                            <DatePicker
                                className="as-date-container"
                                selected={endTime}
                                onChange={(date) => setEndTime(date)}
                                timeIntervals={10}
                                showTimeSelect
                                showTimeSelectOnly
                                dateFormat="hh:mm a"
                            />
                        </div>
                    </CommonInputRow>
                    <CommonCheckbox
                        id='active'
                        label='Is Active Shift'
                        value={isActive}
                        onChange={() => {
                            setIsActive(!isActive)
                        }}
                    />
                    <CommonCheckbox
                        id='nomination'
                        label='Is shift open for employee(s) assignment'
                        value={isNominationOpen}
                        onChange={() => {
                            setIsNominationOpen(!isNominationOpen)
                        }}
                    />
                    {isLoggedInUserBusiness(user) && <div>
                        <FormFieldLabel label='Select Business' />
                        {!isEmpty(userBusinessListSuccess) && !isEmpty(userBusinessListSuccess.data) && <Select
                            className='select-full-width-no-border'
                            value={selectedBusiness}
                            getOptionLabel={e => e.businessName}
                            getOptionValue={e => e}
                            options={userBusinessListSuccess.data}
                            placeholder='Select Business'
                            onChange={e => setSelectedBusiness(e)} />}
                        {!isEmpty(userBusinessListError) && <div className="p-text">{userBusinessListError.message}</div>}
                        {!isEmpty(selectedBusiness) && <div>
                            <FormFieldLabel label='Select Business Location' />
                            {!isEmpty(businessLocationListSuccess) && !isEmpty(businessLocationListSuccess.data) && <Select
                                className='select-full-width-no-border'
                                value={selectedLocation}
                                getOptionLabel={e => e.name}
                                getOptionValue={e => e}
                                options={businessLocationListSuccess.data}
                                placeholder='Select Location'
                                onChange={e => setSelectedLocation(e)} />}
                            {!isEmpty(businessLocationListError) && <div className="p-text">{businessLocationListError.message}</div>}
                        </div>}
                    </div>}
                    <div className="ae-cb-row-container">
                        <div className="ae-phone-input-container">
                            <CommonCheckbox id='assignProject'
                                label='Assign Project'
                                onChange={e => setIsAssignProject(e.target.checked)}
                                value={isAssignProject}
                            />
                        </div>
                        {isAssignProject === true && !isEmpty(projectListSuccess) && !isEmpty(projectListSuccess.data) && <Select
                            className='select-full-width-no-border'
                            value={selectedProject}
                            getOptionLabel={e => e.name}
                            getOptionValue={e => e}
                            options={projectListSuccess.data}
                            placeholder='Select Project'
                            onChange={e => setSelectedProject(e)} />}
                        {!isEmpty(projectListError) && <div className="content-error">{projectListError.message}</div>}
                    </div>
                    <ButtonRow>
                        <CommonButton label='Submit' onClick={() => { handleSubmitClick() }} />
                    </ButtonRow>
                </CommonFormBorder>
            </CommonScreenContent>
            <ToastContainer />
            <Loader active={isLoading} text='Please wait...' />
        </>
    )
}

export default AddShift